import InterviewConfirmationModal from './InterviewConfirmationModal.component';

export default InterviewConfirmationModal;
